/* eslint-disable */
import * as Types from './types';

import { ImageFragmentDoc } from './Image';
export type DesktopMainMenuFragment = { __typename?: 'DesktopMainMenu', navigationItemCollection?: { __typename?: 'DesktopMainMenuNavigationItemCollection', items: Array<{ __typename?: 'NavigationItem', text?: string | null, url?: string | null, openLinkInNewTab?: boolean | null, sys: { __typename?: 'Sys', id: string }, nestedNavigationItemCollection?: { __typename?: 'NavigationItemNestedNavigationItemCollection', items: Array<{ __typename?: 'NavigationItem', text?: string | null, url?: string | null, openLinkInNewTab?: boolean | null, sys: { __typename?: 'Sys', id: string }, nestedNavigationItemCollection?: { __typename?: 'NavigationItemNestedNavigationItemCollection', items: Array<{ __typename?: 'NavigationItem', text?: string | null, url?: string | null, openLinkInNewTab?: boolean | null, sys: { __typename?: 'Sys', id: string }, image?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null> } | null } | null> } | null, navigationBlockCollection?: { __typename?: 'NavigationItemNavigationBlockCollection', items: Array<{ __typename?: 'NavigationBlock', title?: string | null, blockMediaCollection?: { __typename?: 'NavigationBlockBlockMediaCollection', items: Array<{ __typename?: 'MediaBlock', text?: string | null, url?: string | null, openLinkInNewTab?: boolean | null, blockImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null> } | null } | null> } | null } | null> } | null };

export declare const DesktopMainMenuFragment: import("graphql").DocumentNode;
export const DesktopMainMenuFragmentDoc = /*#__PURE__*/ `
    fragment DesktopMainMenuFragment on DesktopMainMenu {
  navigationItemCollection(limit: 10) {
    items {
      sys {
        id
      }
      text
      url
      openLinkInNewTab
      nestedNavigationItemCollection(limit: 5) {
        items {
          sys {
            id
          }
          text
          url
          openLinkInNewTab
          nestedNavigationItemCollection(limit: 10) {
            items {
              sys {
                id
              }
              text
              url
              openLinkInNewTab
              image {
                ...ImageFragment
              }
            }
          }
        }
      }
      navigationBlockCollection(limit: 1) {
        items {
          title
          blockMediaCollection {
            items {
              text
              url
              openLinkInNewTab
              blockImage {
                ...ImageFragment
              }
            }
          }
        }
      }
    }
  }
}
    `;